import React, { useState } from 'react';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { FormInput } from 'components/form';
import { DialogHeader } from 'components/shared/Dialog/DialogHeader';
import {
  Box,
  Stack,
  Dialog,
  Button,
  Checkbox,
  Typography,
  DialogActions,
  DialogContent,
  FormControlLabel,
} from '@mui/material';

export const AddContingencyDialog = () => {
  const { handleClose, isOpen } = useModal(ModalsKeys.AddContingencyDialog);

  const [selectedItems, setSelectedItems] = useState<Array<string>>([]);
  const [searchValue, setSearchValue] = useState<string>('');

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="md" fullWidth={true}>
      <DialogHeader label="Add Contingency" handleClose={handleClose} />

      <DialogContent dividers>
        <Stack gap="1rem">
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 10rem', gap: '1rem' }}>
            <FormInput value={searchValue} onChange={v => setSearchValue(v)} label="Search" variant="outlined" />

            <Button size="small" variant="contained" onClick={() => {}}>
              Create new
            </Button>
          </Box>

          <Stack>
            <Typography fontWeight="bold">Contingency List</Typography>

            <>
              {[].map(({ label, value }) => (
                <FormControlLabel
                  label={label}
                  control={
                    <Checkbox
                      value={selectedItems.includes(value)}
                      onChange={({ target }, checked) => {
                        setSelectedItems(prev => {
                          if (checked) return [...prev, target.value];
                          return prev.filter(item => item !== target.value);
                        });
                      }}
                    />
                  }
                />
              ))}
            </>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>

        <Button variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
};
